import React from "react";
import { Route, Switch } from "react-router-dom";

import { routing } from "routing";

import { TeamManagement } from "modules/team-management";
import { Overview } from "modules/overview";
import { Calendar } from "modules/calendar";
import { WithballDataInput } from "modules/withball-data-input";
import { MatchStats, MatchTeamStats } from "modules/match-stats";
import { TeamStats } from "modules/team-stats";

import { SelectTeamNotify } from "modules/main/SelectTeamNotify";

const { Urls } = routing;

export const MainRoutes = () => {
  return (
    <Switch>
      <Route exact path={Urls.PLATFORM()} component={Overview} />
      <Route exact path={Urls.TEAM_STATS_PATTERN} component={TeamStats} />
      <Route
        exact
        path={Urls.TEAM_SELECTED_STATS_PATTERN}
        component={TeamStats}
      />
      <Route
        exact
        path={Urls.SELECT_TEAM_NOTIFY()}
        component={SelectTeamNotify}
      />
      <Route path={Urls.TEAM_MANAGEMENT()} component={TeamManagement} />
      <Route path={Urls.CALENDAR()} component={Calendar} />
      <Route
        path={Urls.WITHBALL_DATA_INPUT_URL_PATTERN}
        component={WithballDataInput}
      />
      <Route path={Urls.WITHBALL_DATA_INPUT()} component={WithballDataInput} />
      <Route
        path={Urls.MATCH_TEAM_PLAYER_STATS_PATTERN}
        component={MatchTeamStats}
      />
      <Route path={Urls.MATCH_TEAM_STATS_PATTERN} component={MatchTeamStats} />
      <Route path={Urls.MATCH_STATS_PATTERN} component={MatchStats} />
    </Switch>
  );
};
